import {Component, OnDestroy, OnInit} from "@angular/core";
import {UserHttpClientService} from "../../../data/user-http-client.service";
import {Subscription} from "rxjs/internal/Subscription";
import { environment } from "src/environments/environment";

@Component({
    templateUrl: "./profile-nav.component.html"
})
export class ProfileNavComponent implements OnInit, OnDestroy {
    userDetails$ = new Subscription();
    isAuthorized = true;
    environment: any

    constructor(private userHttpClient: UserHttpClientService) {
      this.environment = environment
    }

    ngOnInit() {
        this.userDetails$ = this.userHttpClient.getUserDetails().subscribe(
            {
                next: user => {
                    this.isAuthorized = user.is_authorized;
                }
            }
        );
    }

    ngOnDestroy() {
        this.userDetails$.unsubscribe();
    }
}
